import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import './styles/statistic.scss';


export default /*#__PURE__*/_defineComponent({
  __name: 'Statistic',
  props: {
  value: {
    type: Number,
    default: 0
  },
  isFetched: {
    type: Boolean
  },
  isError: {
    type: Boolean
  },
  i18nLabel: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props;



const statistic = ref(0);

watch(
  () => props.value,
  () => {
    statistic.value = props.value;
  },
  { immediate: true }
);

return { __sfc: true,props, statistic }
}

})